import React, { useEffect, useState } from 'react';
import './AnimatedCursor.scss';

const AnimatedCursor = ({
  innerSize = 8,
  outerSize = 28,
  color = '193, 11, 111',
  outerAlpha = 0.2,
  innerScale = 0.7,
  outerScale = 3,
  clickables = [],
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const updateCursor = e => {
      setPosition({ x: e.clientX, y: e.clientY });
      setIsVisible(true);
    };

    const handleMouseOver = e => {
      const target = e.target;
      const isClickable = clickables.some(selector => {
        try {
          return target.matches(selector);
        } catch (err) {
          return false;
        }
      });
      setIsHovering(isClickable);
    };

    const handleMouseOut = () => {
      setIsHovering(false);
    };

    const handleMouseLeave = () => {
      setIsVisible(false);
    };

    window.addEventListener('mousemove', updateCursor);
    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseout', handleMouseOut);
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      window.removeEventListener('mousemove', updateCursor);
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseout', handleMouseOut);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [clickables]);

  if (!isVisible) return null;

  return (
    <>
      <div
        className="cursor-outer"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          width: `${outerSize}px`,
          height: `${outerSize}px`,
          backgroundColor: `rgba(${color}, ${outerAlpha})`,
          transform: `translate(-50%, -50%) scale(${isHovering ? outerScale : 1})`,
        }}
      />
      <div
        className="cursor-inner"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          width: `${innerSize}px`,
          height: `${innerSize}px`,
          backgroundColor: `rgb(${color})`,
          transform: `translate(-50%, -50%) scale(${isHovering ? innerScale : 1})`,
        }}
      />
    </>
  );
};

export default AnimatedCursor;
